import React, {memo} from "react";
import AppDotLink from "../components/home/AppDotLink"
import HomeBGImage from '../assets/img/background/home-bg.png'
import PhotoAnimation, {Images} from "../components/animation/PhotoAnimation";
import {FrontendRoutes} from "../constants";
import HelpdeskModal from "../components/common/HelpdeskModal";


function HomePage() {
    const [width, setWidth] = React.useState(window.innerWidth > 900 ? window.innerWidth * 0.6 : window.innerWidth * 0.6);
    const [loading, setLoading] = React.useState(true);
    const [modalIsOpen, setModalIsOpen] = React.useState(false);

    const counter = React.useRef(0);
    const imageLoaded = () => {
        counter.current += 1;
        if (counter.current >= 0) {
            setLoading(false);
        }
    }

    React.useEffect(() => {
        function handleResize() {
            if (window.innerWidth > 900) {
                setWidth(window.innerWidth * 0.6)
            } else {
                setWidth(window.innerWidth * 0.6)
            }
        }

        window.addEventListener('resize', handleResize)
    })

    return (
        <div>
            <div style={{display: loading ? "none" : "flex", justifyContent: "center"}} id={'image-mapper'}>
                <div className="imagepos" style={{marginTop: '1.1vw', zIndex: 1}}>
                    <PhotoAnimation images={Images.SBA_2020_HOME_IMGS}
                                    onLoad={imageLoaded}
                                    fps={12}
                                    width={width * 1.02}
                    />
                    <HelpdeskModal modalIsOpen={modalIsOpen}
                                   closeModal={() => setModalIsOpen(false)}
                    />
                    <AppDotLink
                        imgWidth={width}
                        url={FrontendRoutes.PROGRAMME}
                        leftFactor={0.515}
                        topFactor={-0.02}
                    />
                    <AppDotLink
                        imgWidth={width}
                        url={FrontendRoutes.BALLROOM()}
                        leftFactor={0.13}
                        topFactor={0.26}
                    />
                    {/*<AppDotLink*/}
                    {/*    imgWidth={width}*/}
                    {/*    url={FrontendRoutes.CONVERSATION}*/}
                    {/*    leftFactor={0.34}*/}
                    {/*    topFactor={0.35}*/}
                    {/*/>*/}
                    {/*<AppDotLink*/}
                    {/*    imgWidth={width}*/}
                    {/*    url={false}*/}
                    {/*    onClick={() => setModalIsOpen(true)}*/}
                    {/*    leftFactor={0.65}*/}
                    {/*    topFactor={0.12}*/}
                    {/*/>*/}
                    <AppDotLink
                        imgWidth={width}
                        url={FrontendRoutes.PHOTO_BOOTH}
                        leftFactor={0.485}
                        topFactor={0.255}
                    />
                    <AppDotLink
                      imgWidth={width}
                      url={'http://www.sbawards.com.sg/'}
                      external={true}
                      leftFactor={0.83}
                      topFactor={0.21}
                    />
                    <AppDotLink
                        imgWidth={width}
                        url={FrontendRoutes.SOCIAL_WALL}
                        leftFactor={0.94}
                        topFactor={0.26}
                    />
                </div>
            </div>
        </div>
    );
}

export default memo(HomePage);
